import { render, staticRenderFns } from "./form-input-option.vue?vue&type=template&id=68d490e7&lang=pug&"
import script from "./form-input-option.vue?vue&type=script&lang=js&"
export * from "./form-input-option.vue?vue&type=script&lang=js&"
import style0 from "./form-input-option.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports